module.exports = __webpack_public_path__ + "media/images/icons/excerpt-662719a3ad07803d141e89c25bf74fc9.svg";